module.exports = __webpack_public_path__ + "static/media/header_logo.e80d2f98.webp";